<script>
import Vue from 'vue'
import { MODAL } from '@constants/Text'
import { GlobalBus } from '@services/bus'
import { apiAtendimentoConexao } from '@modules/settings/api/apiAtendimentoConexao'

export default {
  name: 'ModalTermosAtendimento',
  data() {
    return {
      busModal: new Vue(),
      loading: false,
      loadingTermos: false,
      aceito: false,
      termos: null,
      callback: null,
    }
  },
  created() {
    GlobalBus.$on(MODAL.ATENDIMENTO_TERMOS, this.open)
  },
  beforeDestroy() {
    GlobalBus.$off(MODAL.ATENDIMENTO_TERMOS, this.open)
  },
  methods: {
    open({ callback } = {}) {
      this.aceito = false
      this.callback = callback || null
      this.termos = null
      this.busModal.$emit('dialog', true)
      this.fetchTermos()
    },

    async fetchTermos() {
      this.loadingTermos = true
      try {
        const r = await apiAtendimentoConexao.getTermos()
        if (r && r.status === 200 && r.value) {
          this.termos = r.value
        }
      } finally {
        this.loadingTermos = false
      }
    },

    async aceitar() {
      if (!this.aceito) return
      if (this.loading) return

      this.loading = true
      try {
        const r = await apiAtendimentoConexao.aceitarTermos()
        if (r && r.status === 200 && r.value) {
          this.busModal.$emit('dialog', false)
          if (this.callback) {
            this.callback({ id_aceite_termos: r.value.id })
          }
        } else {
          this.$showSnack({
            text: (r && r.message) || 'Erro ao registrar aceite',
            button: true,
          })
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<template>
  <BaseModal
    centerScreen
    :bus="busModal"
    persistent
    centerAndDecreasesPadding
    maxWidth="55%"
    closeColor="#8e8e8e"
    backgroundColor="white"
  >
    <div class="pb-6">
      <div class="modal-title-container">
        <span class="modal-title">Termos de Uso</span>
      </div>

      <div class="modal-content">
        <div
          v-if="loadingTermos"
          class="d-flex justify-center align-center py-8"
        >
          <v-progress-circular indeterminate color="primary" />
        </div>

        <template v-else-if="termos">
          <div class="d-flex align-center justify-space-between mb-3">
            <span class="az-text-primary az-size-14">
              {{ termos.titulo }}
            </span>
            <span class="az-text-primary az-size-12 az-muted">
              Versão {{ termos.versao }}
            </span>
          </div>

          <div class="termos-container pa-4 rounded">
            <div v-for="(secao, idx) in termos.secoes" :key="idx" class="mb-4">
              <div class="az-text-primary az-size-14 mb-1">
                {{ secao.titulo }}
              </div>
              <div class="az-text-primary az-size-14 az-muted">
                {{ secao.conteudo }}
              </div>
            </div>
          </div>

          <div class="mt-4">
            <v-checkbox v-model="aceito" hide-details class="mt-0">
              <template v-slot:label>
                <span class="az-text-primary az-size-14">
                  Li e concordo com os <strong>Termos de Uso</strong> do módulo
                  de Mensagens WhatsApp
                </span>
              </template>
            </v-checkbox>
          </div>
        </template>
      </div>
    </div>

    <template v-slot:actions="{ close }">
      <BaseButton underlined @click="close"> Cancelar </BaseButton>
      <BaseButton
        primary
        :loading="loading"
        :disabled="!aceito || loading"
        @click="aceitar"
      >
        Aceitar e Continuar
      </BaseButton>
    </template>
  </BaseModal>
</template>

<style lang="sass" scoped>
.termos-container
  max-height: 400px
  overflow-y: auto
  background-color: #fafafa
  border: 1px solid #e0e0e0
</style>
